/**
 * Editor de ações corretivas (GUPM-213) — a lista de `AcaoCard` + "Adicionar nova ação",
 * controlado (recebe `acoes` e emite `onChange`). Extraído do NovoPlanoModal para ser
 * compartilhado com a BAIXA da TARP (o card manda "reaproveitar o form Novo Plano").
 * A 1ª ação é permanente (garante ≥1 ação — fiel ao `closeTarpFinal` do V8).
 */
import { Button } from '@/ui';
import { addAcao, patchAcao, removeAcao, type AcaoDraft } from '@/domain/planos/acoes';
import { AcaoCard } from './AcaoCard';
import { novaAcaoId } from './acaoId';

interface Props {
  acoes: AcaoDraft[];
  onChange: (acoes: AcaoDraft[]) => void;
  /** Data de abertura — referência do prazo em dias úteis por ação. */
  abertura: string;
  /** FLAT (baixa da TARP): ações sem card, campos escuros direto no bloco — evita "card
   *  dentro de card". Default false = card escuro por ação (Novo Plano). */
  flat?: boolean;
}

export function AcoesEditor({ acoes, onChange, abertura, flat = false }: Props) {
  return (
    <>
      {acoes.map((a, i) => (
        <AcaoCard
          key={a.id}
          acao={a}
          index={i}
          abertura={abertura}
          podeRemover={i > 0}
          flat={flat}
          onPatch={(patch) => onChange(patchAcao(acoes, a.id, patch))}
          onRemove={() => onChange(removeAcao(acoes, a.id))}
        />
      ))}
      <div className="col-span-2">
        <Button variant="ghost" type="button" onClick={() => onChange(addAcao(acoes, novaAcaoId()))}>
          + Adicionar nova ação
        </Button>
      </div>
    </>
  );
}
